<template>
  <div>
    <div v-if="!ehMobile && menuDesktopAberto && !sidebarMinimizada" class="sidebar-overlay-desktop" @click="alterarSidebar">
    </div>

    <v-navigation-drawer class="sidebar" :class="{
      'sidebar-mobile': ehMobile,
      'sidebar-desktop': !ehMobile
    }" v-model="drawerDesktop" :temporary="ehMobile" :permanent="!ehMobile" :fixed="true"
      :touchless="ehMobile" height="100%"
      :width="ehMobile ? '305' : (sidebarMinimizada ? '114' : '305')" :mini-variant="sidebarMinimizada && !ehMobile"
      :mini-variant-width="sidebarMinimizada ? '114' : '305'">
      <div class="d-flex flex-column justify-center align-center logo-container">
        <div v-if="ehMobile" class="d-flex justify-end w-100 pr-4 pt-2">
          <v-btn icon @click="fecharMenuMobile" class="btn-fechar-mobile">
            <v-icon color="white">mdi-arrow-left</v-icon>
          </v-btn>
        </div>
        <div class="d-flex flex-row align-center">
          <div class="logo-mini" v-show="sidebarMinimizada && !ehMobile">
            <v-img :src="logoEspecialidade" @click="alterarSidebar" />
          </div>
          <div class="logo-full" v-show="!sidebarMinimizada || ehMobile">
            <v-img :src="logoEspecialidade" @click="ehMobile ? fecharMenuMobile() : alterarSidebar()"
              style="cursor: pointer;" />
          </div>
        </div>
        <v-divider class="mx-auto sidebar-divider" :class="sidebarMinimizada ? 'sidebar-divider-mini' : ''"></v-divider>
        <aviso-inadimplencia-carencia v-if="ambienteProducao" :miniSidebar="sidebarMinimizada" />
      </div>
      <div class="navbar sidebar-content" ref="sidebarContent">
        <v-list nav dense class="navbar-list-full">
          <template v-for="(item, index) in items">
            <!-- ATENÇÃO: item.name !== 'campanhas' é uma condição provisória para não exibir o item campanhas na sidebar (issue-1197) -->
            <template v-if="temPermissaoNoItem(item) && item.name !== 'campanhas'">
              <div :key="index" v-show="verificaAcesso(item.roles, item.permissions)">
                <v-list-item :disabled="desabilitaModulosComplementares(item.roles, item.permissions)"
                  :class="[!sidebarMinimizada ? 'navbar-item-full' : 'navbar-item-mini', { 'v-list-item--active': isActive(item) }]"
                  :ripple="!!obterCaminhoItem(item)" @click="aoClicarItemRaiz(item)">
                  <v-icon :size="!sidebarMinimizada ? '20' : '30'" class="navbar-item-icon">{{ item.icon }}</v-icon>
                  <v-list-item-title class="navbar-item-title">
                    {{ item.label }}
                  </v-list-item-title>
                </v-list-item>
                <div v-for="child in item.children" :key="child.name"
                  :class="['navbar-child', { 'mini-mode': sidebarMinimizada }]">
                  <v-list-item v-show="verificaAcesso(child.roles, child.permissions) && !sidebarMinimizada"
                    :class="[!sidebarMinimizada ? 'navbar-child-full' : 'navbar-child-mini', { 'v-list-item--active': isActive(child) }]"
                    :ripple="true" @click="aoClicarNavegacao(child.path)">
                    <v-icon size="12" class="navbar-child-icon"> $arrowRight </v-icon>
                    <v-tooltip v-if="naoTemPermissaoTriagem(child)" bottom>
                      <template #activator="{ on, attrs }">
                        <v-list-item-title v-bind="attrs" v-on="on"
                          :class="['navbar-child-title', { disabled: naoTemPermissaoTriagem(child) }]">
                          {{ child.label }}
                        </v-list-item-title>
                      </template>
                      <span>
                        Entre em contato pelo telefone 0800 707 5900 para<br>
                        adquirir essa funcionalidade
                      </span>
                    </v-tooltip>
                    <v-list-item-title v-else
                      :class="['navbar-child-title', { 'disabled': naoTemPermissaoTriagem(child) }]">
                      {{ child.label }}
                    </v-list-item-title>
                  </v-list-item>
                </div>
              </div>
            </template>
          </template>
        </v-list>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import sidebarItems, { IMenuItem } from '../router/sidebar';
import { decode, getToken } from '../utils/Token';
import PermissoesPadrao from '@/constants/enums/PermissoesPadrao';
import { useEspecialidade } from '@/composables/useEspecialidade';
import AvisoInadimplenciaCarencia from './SideBar/AvisoInadimplenciaCarencia.vue';

export default Vue.extend({
  components: {
    AvisoInadimplenciaCarencia,
  },
  name: 'sidebar',
  data() {
    return {
      sidebarMinimizada: this.$store.state.layout?.sidebarMinimizada ?? false,
      menuDesktopAberto: true,
      ambienteProducao: process.env.NODE_ENV === 'production',
      isMobile: false,
      menuMobileAberto: false,
      permitirAbrirMobile: false,
      get items() {
        return sidebarItems;
      },
    };
  },
  computed: {
    ehMobile(): boolean {
      return this.isMobile;
    },
    drawerDesktop: {
      get(): boolean {
        if (this.ehMobile) {
          return this.menuMobileAberto;
        }
        return this.menuDesktopAberto;
      },
      set(valor: boolean) {
        if (this.ehMobile) {
          if (valor && !this.permitirAbrirMobile) {
            return;
          }
          if (this.menuMobileAberto !== valor) {
            this.menuMobileAberto = valor;
          }
        } else {
          this.menuDesktopAberto = valor;
        }
      },
    },
  },
  mounted() {
    this.verificarLarguraTela();
    window.addEventListener('resize', this.verificarLarguraTela);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.verificarLarguraTela);
  },
  setup() {
    const { logoAtual, definirEspecialidade } = useEspecialidade();

    return {
      logoEspecialidade: logoAtual,
      definirEspecialidade,
    };
  },
  watch: {
    value() {
      this.sidebarMinimizada = this.value;
    },
    menuMobileAberto(novoValor) {
      if (this.ehMobile) {
        this.$nextTick(() => {
          const overlays = document.querySelectorAll('.v-overlay');
          overlays.forEach((overlay: any) => {
            if (overlay) {
              overlay.style.display = 'none';
              overlay.style.opacity = '0';
              overlay.style.pointerEvents = 'none';
              overlay.style.zIndex = '-1';
            }
          });

          const sidebar = document.querySelector('.sidebar-mobile') as HTMLElement;
          const sidebarVuetify = document.querySelector('.v-navigation-drawer.sidebar-mobile') as HTMLElement;

          if (novoValor) {
            if (sidebar) {
              sidebar.style.transform = 'translateX(0)';
              sidebar.setAttribute('aria-expanded', 'true');
            }
            if (sidebarVuetify) {
              sidebarVuetify.style.transform = 'translateX(0)';
              sidebarVuetify.setAttribute('aria-expanded', 'true');
            }
          } else {
            if (sidebar) {
              sidebar.style.transform = 'translateX(-100%)';
              sidebar.setAttribute('aria-expanded', 'false');
            }
            if (sidebarVuetify) {
              sidebarVuetify.style.transform = 'translateX(-100%)';
              sidebarVuetify.setAttribute('aria-expanded', 'false');
            }
          }
        });
      }
    },
    $route: {
      handler(to, from) {
        if (from && to.path === from.path) return;
        this.$nextTick(() => {
          if (this.ehMobile) {
            this.fecharMenuMobile();
          } else {
            this.sidebarMinimizada = true;
            this.$store.commit('layout/DEFINIR_SIDEBAR_MINIMIZADA', true);
            this.$emit('sidebarMinimizada', this.sidebarMinimizada);
          }
        });
      },
      immediate: false,
    },
  },
  methods: {
    naoTemPermissaoTriagem(child: IMenuItem): boolean {
      const sessaoUsuario = decode(getToken());
      const triagemNome = child.name === 'triagens';
      const temPermissao = sessaoUsuario.permissions.includes(PermissoesPadrao.AcessoTriagem);
      return triagemNome && !temPermissao;
    },

    alterarSidebar() {
      if (!this.ehMobile) {
        this.sidebarMinimizada = !this.sidebarMinimizada;
        this.$store.commit('layout/DEFINIR_SIDEBAR_MINIMIZADA', this.sidebarMinimizada);
        this.$emit('sidebarMinimizada', this.sidebarMinimizada);
      }
    },

    abrirMenuMobile() {
      if (this.ehMobile) {
        this.permitirAbrirMobile = true;
        this.menuMobileAberto = true;
        this.$nextTick(() => {
          this.permitirAbrirMobile = false;
        });

        this.$nextTick(() => {
          const overlays = document.querySelectorAll('.v-overlay');
          overlays.forEach((overlay: any) => {
            if (overlay) {
              overlay.style.display = 'none';
              overlay.style.opacity = '0';
              overlay.style.pointerEvents = 'none';
              overlay.style.zIndex = '-1';
            }
          });

          const sidebar = document.querySelector('.sidebar-mobile') as HTMLElement;
          const sidebarVuetify = document.querySelector('.v-navigation-drawer.sidebar-mobile') as HTMLElement;

          if (sidebar) {
            sidebar.style.zIndex = '2000';
            sidebar.style.display = 'block';
            sidebar.style.visibility = 'visible';
            sidebar.style.opacity = '1';
            sidebar.style.transform = 'translateX(0)';
            sidebar.setAttribute('aria-expanded', 'true');
          }

          if (sidebarVuetify) {
            sidebarVuetify.style.zIndex = '2000';
            sidebarVuetify.style.display = 'block';
            sidebarVuetify.style.visibility = 'visible';
            sidebarVuetify.style.opacity = '1';
            sidebarVuetify.style.transform = 'translateX(0)';
            sidebarVuetify.setAttribute('aria-expanded', 'true');
          }
        });
      }
    },

    fecharMenuMobile() {
      if (this.ehMobile) {
        this.menuMobileAberto = false;

        this.$nextTick(() => {
          const sidebar = document.querySelector('.sidebar-mobile') as HTMLElement;
          const sidebarVuetify = document.querySelector('.v-navigation-drawer.sidebar-mobile') as HTMLElement;

          if (sidebar) {
            sidebar.style.transform = 'translateX(-100%)';
            sidebar.removeAttribute('aria-expanded');
            sidebar.setAttribute('aria-expanded', 'false');
          }

          if (sidebarVuetify) {
            sidebarVuetify.style.transform = 'translateX(-100%)';
            sidebarVuetify.removeAttribute('aria-expanded');
            sidebarVuetify.setAttribute('aria-expanded', 'false');
          }
        });
      }
    },

    obterCaminhoItem(item: IMenuItem): string {
      return item.children.length === 0 ? item.path : '';
    },

    deveNavegarDiretoNoDesktopMinimizado(item: IMenuItem): boolean {
      const nomeItem = (item.name || '').toLowerCase();
      return nomeItem === 'home' || nomeItem === 'agenda';
    },

    aoClicarItemRaiz(item: IMenuItem) {
      const caminho = this.obterCaminhoItem(item);

      if (!this.ehMobile && this.sidebarMinimizada) {
        if (this.deveNavegarDiretoNoDesktopMinimizado(item) && caminho) {
          this.aoClicarNavegacao(caminho);
          return;
        }

        this.sidebarMinimizada = false;
        this.$store.commit('layout/DEFINIR_SIDEBAR_MINIMIZADA', false);
        this.$emit('sidebarMinimizada', false);
        return;
      }

      this.aoClicarNavegacao(caminho);
    },

    aoClicarNavegacao(caminho: string) {
      if (this.ehMobile) {
        this.fecharMenuMobile();
      } else if (!this.sidebarMinimizada) {
        this.sidebarMinimizada = true;
        this.$store.commit('layout/DEFINIR_SIDEBAR_MINIMIZADA', true);
        this.$emit('sidebarMinimizada', this.sidebarMinimizada);
      }
      if (caminho && this.$route.path !== caminho) {
        this.$nextTick(() => {
          this.$router.push(caminho);
        });
      }
    },

    verificaAcesso(roles: string[], permissions: string[]) {
      const sessaoUsuario = decode(getToken());
      const temRoleValido = roles.includes(sessaoUsuario.role);
      const temPermissoesValidas = permissions.length === 0 || permissions.every((perm) => sessaoUsuario.permissions.includes(perm));
      return temRoleValido && temPermissoesValidas;
    },

    temPermissaoNoItem(item: IMenuItem) {
      if ((item.permissions && item.permissions.length > 0) || item.children) {
        return this.verificaAcesso(item.roles, item.permissions);
      } if (item.children && item.children.length > 0) {
        return item.children.some((child) => this.temPermissaoNoItem(child));
      }
      return false;
    },

    desabilitaModulosComplementares(roles: IMenuItem['roles'], permissions: IMenuItem['permissions']) {
      const sessaoUsuario = decode(getToken());
      const temRoleValido = roles.includes(sessaoUsuario.role);
      const temPermissoesValidas = permissions.every((perm) => sessaoUsuario.permissions.includes(perm));
      return !(temRoleValido && temPermissoesValidas);
    },

    isActive(route: IMenuItem): boolean {
      if (this.$route.name === route.name) return true;
      if (this.sidebarMinimizada && route.children && route.children.length > 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (const child of route.children) {
          if (child.name === this.$route.name) return true;
        }
        return route.children.some((child) => child.relatedRoutes && child.relatedRoutes.includes(this.$route.name));
      }
      if (route.relatedRoutes) {
        return route.relatedRoutes.some((name: string) => name === this.$route.name);
      }
      return false;
    },

    verificarLarguraTela() {
      const larguraTela = window.innerWidth;
      const eraMobile = this.isMobile;
      this.isMobile = larguraTela < 960;

      if (!eraMobile && this.isMobile) {
        this.menuMobileAberto = false;
        this.sidebarMinimizada = false;
      } else if (eraMobile && !this.isMobile) {
        this.menuMobileAberto = false;
        this.menuDesktopAberto = true;
        this.$emit('sidebarMinimizada', this.sidebarMinimizada);
      }

      this.$emit('mobile-changed', this.isMobile);
    },

  },
});
</script>

<style>
@media (max-width: 959px) {
  .v-overlay {
    display: none !important;
    opacity: 0 !important;
    pointer-events: none !important;
    z-index: -1 !important;
  }

  .v-overlay--active {
    display: none !important;
    opacity: 0 !important;
    pointer-events: none !important;
    z-index: -1 !important;
  }
}

.sidebar {
  background: var(--especialidade-primary) !important;
  border: none;
  top: 0;
  left: 0;
  transition: transform 0.3s ease-in-out, width 0.3s ease-in-out !important;
}

.sidebar-desktop:not(.v-navigation-drawer--mini-variant) {
  position: fixed !important;
  z-index: 998 !important;
}

.sidebar-desktop.v-navigation-drawer--mini-variant {
  position: fixed !important;
  z-index: 996 !important;
}

.sidebar-mobile {
  position: fixed !important;
  height: 100vh !important;
  left: 0 !important;
  top: 0 !important;
  z-index: 2000 !important;
  transition: transform 0.3s ease-in-out !important;
  width: 305px !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.sidebar-mobile {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.sidebar-mobile:not(.v-navigation-drawer--active):not([aria-expanded="true"]),
.sidebar-mobile[aria-expanded="false"] {
  transform: translateX(-100%) !important;
}

.sidebar-mobile.v-navigation-drawer--active,
.sidebar-mobile[aria-expanded="true"] {
  transform: translateX(0) !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

@media (max-width: 959px) {
  .sidebar-mobile[style*="display"] {
    display: block !important;
  }

  .v-navigation-drawer--temporary.v-navigation-drawer--active {
    transform: translateX(0) !important;
    visibility: visible !important;
    opacity: 1 !important;
    display: block !important;
  }
}

@media (max-width: 959px) {
  .sidebar-mobile {
    position: fixed !important;
  }

  .v-main,
  .main-content-overlay {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .v-overlay.v-overlay--active {
    display: none !important;
    opacity: 0 !important;
    pointer-events: none !important;
    z-index: -1 !important;
  }

  .v-overlay--active {
    display: none !important;
    background-color: transparent !important;
    opacity: 0 !important;
    pointer-events: none !important;
    z-index: -1 !important;
  }

  .v-navigation-drawer--temporary~.v-overlay,
  .v-navigation-drawer--temporary+.v-overlay {
    display: none !important;
    opacity: 0 !important;
    pointer-events: none !important;
    z-index: -1 !important;
  }

  .sidebar-mobile.v-navigation-drawer--active~.v-overlay,
  .sidebar-mobile.v-navigation-drawer--active+.v-overlay {
    display: none !important;
  }
}

.sidebar-overlay-desktop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 996;
  transition: opacity 0.3s ease-in-out;
  cursor: pointer;
}

body.modal-agendamento-open .sidebar-desktop:not(.v-navigation-drawer--mini-variant),
body.modal-agendamento-open .sidebar-desktop.v-navigation-drawer--mini-variant {
  z-index: 10 !important;
}

body.modal-visualizar-agendamento-open .sidebar-desktop:not(.v-navigation-drawer--mini-variant),
body.modal-visualizar-agendamento-open .sidebar-desktop.v-navigation-drawer--mini-variant {
  z-index: 10 !important;
}

body.modal-revisao-open .sidebar-desktop:not(.v-navigation-drawer--mini-variant),
body.modal-revisao-open .sidebar-desktop.v-navigation-drawer--mini-variant {
  z-index: 10 !important;
}

body.modal-agendamento-open .sidebar-overlay-desktop {
  z-index: 9 !important;
}

body.modal-visualizar-agendamento-open .sidebar-overlay-desktop {
  z-index: 9 !important;
}

body.modal-revisao-open .sidebar-overlay-desktop {
  z-index: 9 !important;
}

.v-navigation-drawer--fixed {
  position: fixed !important;
}


.logo-container {
  min-height: 80px;
  padding: 10px 0;
}

.btn-fechar-mobile {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
}

.w-100 {
  width: 100%;
}

.pr-4 {
  padding-right: 1rem;
}

.pt-2 {
  padding-top: 0.5rem;
}

.sidebar-divider {
  border-color: rgba(255, 255, 255, 0.2) !important;
  width: 17rem;
  margin-right: 1rem;
  margin-left: 1rem;
  margin-top: 1rem;
}

.sidebar-divider-mini {
  border-color: rgba(255, 255, 255, 0.2) !important;
  width: 4.9rem;
  margin-right: 1rem;
  margin-left: 1rem;
}

.logo-full {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 250px;
  max-height: 50px;
  margin-top: 20px;
  margin-left: 15px;
  margin-right: 15px;
  padding: 10px;
}

.logo-full .v-img {
  max-width: 180px;
  max-height: 100%;
  object-fit: contain;
}

.logo-full .v-icon {
  margin-left: 20px;
  margin-right: 20px;
  color: #fff;
}

.logo-mini {
  margin-top: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
}

.logo-mini .v-img {
  max-width: 50px;
  max-height: 50px;
  object-fit: contain;
}

.v-navigation-drawer__border {
  width: 0;
}

.navbar-list-full .navbar-item-full {
  padding-left: 42px;
  margin-bottom: 16px;
}

.navbar-list-full .navbar-child-full {
  padding-left: 72px;
  margin-left: 1rem;
  margin-right: 1rem;
}

.v-list-item--dense,
.v-list--dense .navbar-item-full {
  height: 26px !important;
  margin-left: 1rem;
  margin-right: 1rem;
}

.navbar .navbar-item-title {
  font-weight: 700 !important;
  font-size: 1rem !important;
  line-height: 22px;
  letter-spacing: 2%;
  color: #ffca5a;
  text-transform: uppercase;
}

.navbar .navbar-item-icon {
  color: #ffca5a !important;
}

.navbar .navbar-child-icon {
  color: #fff !important;
}

.navbar .v-list-item--active {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
}

.navbar .v-list-item--active .navbar-item-title {
  color: white !important;
}

.navbar .v-list-item--active .navbar-item-icon {
  color: white !important;
}

.navbar .v-list-item--active .navbar-child-title {
  color: white !important;
}

.navbar .v-list-item--active .navbar-child-icon {
  color: white !important;
}

.navbar-item-full {
  margin-top: 0.5rem !important;
}

.navbar-item-mini {
  margin-top: 0.5rem !important;
  cursor: pointer !important;
  margin-left: 1rem;
  margin-right: 1rem;
}

.sidebar-content {
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 0;
  background-color: transparent;
}
</style>
